// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__244IW","validationTips":"StatementDescriptor_validationTips__OvAvB"};